<template>
    <div class="apply-bootstrap">
        <import c-id="import_importTool"></import>
    </div>
</template>

<script>
import "@common/syncfusionCss";
import importCmp from "./import";

const importExportComponent = {
    components: {
        import: importCmp
    }
};

export default importExportComponent;
</script>
